module.exports = __webpack_public_path__ + "static/media/csv-download.e2c62f90.png";